import { useMatchMedia } from "./use-match-media.js";

/**
 * A React hook for detecting `prefers-reduced-motion`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 *
 * @example const prefersReducedMotion = usePrefersReducedMotion();
 * @returns boolean
 */
var usePrefersReducedMotion = function usePrefersReducedMotion() {
  return useMatchMedia('(prefers-reduced-motion: reduce)');
};
export { usePrefersReducedMotion };